import { ROUTES } from "@/enums/routes";
import { SidebarItem } from "@/types/sidebar";
import { Role } from "@/types/userDetails";
import { LogOut, User } from "lucide-react";

export const headerItems = [
  {
    title: "ETS",
    url: "",
    iconDefault: "/ETS-logo.png",
    iconActive: "/dashboardActive.png",
  },
];

export const getItems = (role: Role): SidebarItem[] => {
  const membersMenu = {
    title: "Members",
    url: ROUTES.MEMBERS,
    icon: User,
  };

  return [
    {
      title: "Dashboard",
      url: ROUTES.DASHBOARD,
      iconDefault: "/dashboard.png",
      iconActive: "/dashboardActive.png",
      height:18,
      width:18,
    },
    {
      title: "Categories",
      url: ROUTES.CATEGORIES,
      iconDefault: "/categories.png",
      iconActive: "/categoriesActive.png",
      height:20,
      width:20,
    },
    {
      title: "Items",
      url: ROUTES.ITEMS,
      iconDefault: "/items.png",
      iconActive: "/itemsActive.png",
      height:20,
      width:20,
    },
    {
      title: "Branches",
      url: ROUTES.BRANCHES,
      iconDefault: "/branches.png",
      iconActive: "/branchesActive.png",
      height:23,
      width:23,
    },
    ...(role.isSuperAdmin ? [membersMenu] : []),
  ];
};

export const footerItems = [
  {
    title: "Log Out",
    url: "",
    icon: LogOut,
  },
];
